import { render, staticRenderFns } from "./MessageReactionList.vue?vue&type=template&id=07e12bd4"
import script from "./MessageReactionList.vue?vue&type=script&lang=js"
export * from "./MessageReactionList.vue?vue&type=script&lang=js"
import style0 from "./MessageReactionList.vue?vue&type=style&index=0&id=07e12bd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports